const interpolateFields = mapping => {
	return (obj, fields) => {
		fields.forEach(field => {
			if (obj && obj[field]) {
				obj[field] = obj[field].replace(mapping.find, mapping.replace);
			}
		});
	};
};

export { interpolateFields };
